import { isEmpty } from 'lodash';
import { Fragment } from 'react';
import { Route, Routes } from 'react-router-dom';

import { NotFoundPage } from 'components';
import { routes } from 'router';

const AppRoutes = () => {
  const appRoutes = Object.values(routes).map((route) => {
    const childrenRoutes = route?.children ? Object.values(route.children) : [];

    return (
      <Fragment key={route.path}>
        <Route exact path={route.path} element={route.component()}>
          {!isEmpty(childrenRoutes) &&
            childrenRoutes.map((childRoute) => (
              <Route key={childRoute.path} path={childRoute.path} element={childRoute.component()} />
            ))}
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Fragment>
    );
  });

  return <Routes>{appRoutes}</Routes>;
};

export default AppRoutes;
